<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil" style="background:#fff;">
            <a-card>
                统计代码：<a-descriptions :title="code"></a-descriptions>
                留言宝样式：<a-descriptions :title="voicecss"></a-descriptions>
                留言宝：<a-descriptions :title="voice"></a-descriptions>
                <!-- <p><span style="color:#333">统计代码：</span>{{code}}</p> -->
                <a-divider />
                <a-row>
                    <h3>代码安装说明 安装实例 建站工具中的安装方法</h3>
                    <p>注意事项：</p>
                    <p> 1. 如果只统计点击流量与来源，请放统计代码</p>
                    <p> 2. 如果是按线索效果付费，需放置全部代码</p>
                    <p v-text="text"> </p>
                    <p> 4. 建议在header.htm类似的页头模板页面中安装，以达到一处安装，全站皆有的效果。</p>
                    <p> 如果代码安装正确，一般20分钟后，可以查看网站分析数据。</p>
                    <h3>代码检测</h3>
                    <p>代码安装完成后，您可以在“代码安装检查”页面自动检测或手动检测代码安装情况。</p> 
                    <h3>小贴士：</h3>
                    <p> 1.此代码不会影响您网站页面的显示，请您放心使用。</p>
                    <p> 2.如果您有技术上的疑问，可咨询您的网站管理员、托管公司，或者百度推广顾问。</p>

               </a-row>
            </a-card>

        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '统计代码'},
            ],
            code:"",
            voice:"",
            voicecss:"",
            text:"3. 请将代码添加到网站全部页面的<head></head>标签之间。",
        }
    },
    mounted(){
        this.$axios.get("/api/getflowcode",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code=200){
                this.code=res.data.data.code
                this.voice=res.data.data.voice
                this.voicecss=res.data.data.voicecss
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/system/statistics.vue